import { z } from "zod"

export const shipmentDocTypeIdSchema = z.string().uuid("ID de tipo de documento de viaje inválido")

export const shipmentDocTypeControlSchema = z.enum(["T", "C"])

export const createShipmentDocTypeSchema = z.object({
  code:    z.string().trim().min(1, "El código es requerido").max(10).toUpperCase(),
  name:    z.string().trim().min(1, "El nombre es requerido").max(200),
  control: shipmentDocTypeControlSchema.nullable().optional(),
  sortOrder: z.number().int().min(0).max(9999).optional(),
})

export const updateShipmentDocTypeSchema = createShipmentDocTypeSchema.partial()

export const shipmentDocTypeQuerySchema = z.object({
  deleted: z.enum(["true", "false"]).optional(),
})

export type ShipmentDocTypeId = z.infer<typeof shipmentDocTypeIdSchema>
export type ShipmentDocTypeControl = z.infer<typeof shipmentDocTypeControlSchema>
export type CreateShipmentDocType = z.infer<typeof createShipmentDocTypeSchema>
export type UpdateShipmentDocType = z.infer<typeof updateShipmentDocTypeSchema>
export type ShipmentDocTypeQuery = z.infer<typeof shipmentDocTypeQuerySchema>
